import React from "react"
import { Toast } from 'antd-mobile';
// import { connect } from "react-redux"
import { environment } from '../../service/baseUrl';
import { TabBar,Modal,Avatar } from 'antd-mobile-v5'
// import { DemoBlock } from 'demos';
import {
    GlobalOutline,
    CompassOutline,
    ExclamationCircleFill,
    ChatCheckOutline,
    UserOutline,StarOutline,SoundOutline,
  } from 'antd-mobile-icons'

import {
    GetWechatOpenId, GetPublicAccountFollowerByOpenId, GetWXUserByOpenId,CreatePublicAccountFollower
} from '../../service/service';
import { useNavigate } from 'react-router-dom';

// import { environment } from '../../assets/';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        return <WrappedComponent {...props} navigate={navigate} />;
    };
};

// 第一步：优先存储iOS首次初始URL，永久生效（跳转后不更新）
const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
// 仅在「没有存储过初始URL」时存储（确保是首次进入的URL，跳转后不覆盖）
if (isIOS) {
  const firstUrl = window.location.href.split('#')[0];
  localStorage.setItem('wxFirstInitUrl', firstUrl);
}

// @connect(mapState, mapDispatch)
class Tab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 'redTab',
            hidden: false,
            fullScreen: true,
            path: "index",
            invoiceState: 0,
            visible: false,
            productCount: 1,
            openid: "",
            userInfo: {},
            data: [],

            mapId: null,
            isShow: false,
            
            productList: [],
            imgList: [],
            imgCount: 0,


            position: props.position,
        };
    }

    componentDidMount() {
        var i = document.getElementsByTagName("meta");
        i[1]["content"] = "width=device-width,initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no";

        document.getElementsByTagName("body")[0].style.height = document.documentElement.clientHeight + "px";

        
        var elebottom = document.getElementById("bottom");
        elebottom.style.height = document.documentElement.clientHeight * 0.1 + "px";
        var elecbottom = document.getElementById("cbottom");
        elecbottom.style.height = document.documentElement.clientHeight * 0.1 + "px";

        var url = window.location.search; //获取url中"?"符后的字串
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
            var str = url.substr(1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
            }
        }

        var openid = localStorage.getItem("openid");
        if (openid == null || openid == "" || openid == undefined) {
            var path = window.location.pathname;
            if (path.includes('/home')) {
              return;
            }

            if (theRequest.code == undefined) {
                window.location.href = environment.wxredirecturi;

                // Toast.info("浏览器异常，请重新进入", 1);
                return;
            }
            GetWechatOpenId(theRequest.code).then(res => {
                if (res.success) {
                    if (res.result.item1) {
                        this.setState({
                            openid: res.result.item2.openId
                        })
                        localStorage.setItem("openid", res.result.item2.openId)
                        if (res.result.item2.headImg != null && res.result.item2.headImg != "") {
                            res.result.item2.headImg = environment.apiEndpoint + "/NNFiles/Img/" + res.result.item2.headImg;
                        }
                        localStorage.setItem("user", JSON.stringify(res.result.item2))
                        // window.location.href = "/my";

                        if (res.result.item2.blacklist) {
                            this.showModal();
                        }
                    } else {
                        Toast.info("内部错误！", 1);
                        this.setState({
                            path: ""
                        })
                    }
                } else {
                    Toast.info("内部错误！", 1);
                    this.setState({
                        path: ""
                    })
                }
            });
        } else {
            this.setState({
                openid: openid
            })

            var state = true;
            var closeFollow = localStorage.getItem("closeFollow");
            if (closeFollow != undefined) {
                closeFollow = new Date(closeFollow);
                closeFollow.setMinutes(closeFollow.getMinutes() + 5);
                if (new Date() < closeFollow) {
                    state = false;
                } else {
                    localStorage.setItem("closeFollow", new Date());
                }
            }

            if (state) {
                GetWXUserByOpenId().then(res => {
                    if (res.success) {
                        if (res.result.headImg != null && res.result.headImg != "") {
                            if (res.result.headImg.indexOf("https://") > -1) {
                                var urls = res.result.headImg.split("https://").filter(Boolean);
                                res.result.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                            } else {
                                res.result.headImg = environment.apiEndpoint + "/NNFiles/Img/" + res.result.headImg;
                            }
                        }
                        localStorage.setItem("user", JSON.stringify(res.result))

                        if (res.result.blacklist) {
                            localStorage.setItem("closeFollow", new Date("2000-01-01"));
                            this.showModal();
                        }
                    }
                })

            }

        }


    }


    showModal = () => {
        Modal.clear();

        Modal.show({
            content: (
                <div style={{ textAlign: 'center', padding: '24px 16px' }}>
                    <ExclamationCircleFill
                        style={{ fontSize: 48, color: '#ff4d4f', marginBottom: 12 }}
                    />
                    <div style={{ fontSize: 18, fontWeight: 500, color: '#333', marginBottom: 8 }}>
                        账号限制通知
              </div>
                    <div style={{ fontSize: 15, color: '#666', lineHeight: 1.5 }}>
                        由于您的账号涉及违规行为，系统已对您进行限制。
                <br />
                        如有疑问，请联系管理员！
              </div>
                    <div style={{ textAlign: "center", marginTop: "9%", textDecoration: "underline" }}>
                        <a href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIzOTA2OTIyMA==#wechat_redirect"
                            style={{ color: "#0538ff" }}>
                            联系管理员</a>
                    </div>
                </div>
            ),
            // 关键修改：调整弹框样式，确保居中 + 合适宽度
            style: {
                width: 'calc(100% - 32px)', // 左右各留 16px 边距，避免贴边
                maxWidth: '400px', // 最大宽度限制（避免在大屏幕上过宽）
                zIndex: 999999999999, // 关键设置
            },
            bodyStyle: {
                borderRadius: '12px',
                margin: '0 auto', // 确保弹框水平居中
            },
            maskStyle: {
                background: 'rgba(0, 0, 0, 0.6)',
                // zIndex: 9999, // 遮罩层稍低于弹框
            },
            closeOnMaskClick: false,
            closeOnAction: false,
            actions: [],
        });
    }

    render() {
        const tabs = [
            {
                key: 'posts',
                title: '银河',
                icon: <CompassOutline />,
            },
            {
                key: 'home',
                title: '星球',
                icon: <GlobalOutline />,
                // badge: '5',
            },
            {
                key: 'plan',
                title: '客服',
                icon: <ChatCheckOutline />,
                // badge: '99+',
            },
            {
                key: 'my',
                title: '我的',
                icon: <UserOutline />,
            },
        ]

        return (
            <div id="bottom" style={{
                backgroundColor: "#fff", bottom: "0px", zIndex: "100",
                position: this.state.position, width: "100%", borderTop: "solid 1px #dedede"
            }}>

                <div id="cbottom" style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}>

                    <TabBar style={{
                        width: "100%"
                    }} safeArea defaultActiveKey={this.props.selectKey} onChange={(key) => {
                        switch (key) {
                            case "posts":
                                this.props.navigate('/posts', { replace: true, state: { from: 'home' } }); // 传递状态
                                break;
                            case "home":
                                this.props.navigate('/index', { replace: true, state: { from: 'home' } }); // 传递状态
                                break;
                            case "plan":
                                
                                Modal.show({
                                    content:
                                        <>
                                            <div style={{ marginTop: "3%" }}>
                                                <Avatar src='https://api.weibinyi.com/images/niannian/nnerweima.jpg'
                                                    style={{ '--size': '250px', 'margin': 'auto' }} />
                                                <div style={{ textAlign: "center", marginTop: "4%" }}>
                                                    长按识别二维码
                                            </div>
                                            </div>
                                        </>,
                                    closeOnMaskClick: true,
                                    actions: [],
                                    bodyStyle: {
                                        width: '100%',  // 设置为屏幕宽度的70%
                                        margin: '0 auto', // 水平居中
                                        // maxWidth: '300px' // 可选：设置最大宽度
                                    },
                                    afterClose: () => {
                                        localStorage.setItem("closeFollow", new Date());
                                    },
                                })
                                break;
                            case "my":
                                this.props.navigate('/my', { replace: true, state: { from: 'home' } }); // 传递状态
                                break;
                            default:
                                break;
                        }
                    }}>
                        {tabs.map(item => (
                            <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
                        ))}
                    </TabBar>

                </div>

            </div>
        );
    }
}

export default withNavigate(Tab);
